import { render, staticRenderFns } from "./banNetworkRecord.vue?vue&type=template&id=c0a57f9e&"
import script from "./banNetworkRecord.vue?vue&type=script&lang=js&"
export * from "./banNetworkRecord.vue?vue&type=script&lang=js&"
import style0 from "./banNetworkRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports